import produce from 'immer'
import { assign, filter } from 'lodash'

import { DELETE_USER, FETCH_USERS } from '../action-types'
import { USERS_INITIAL_STATE } from '../initial-states'

const usersReducer = (state = USERS_INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_USERS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: [],
          latestEvent: undefined,
        }),
      )

    case FETCH_USERS.COMPLETE:
      return produce(state, nextState => {
        const { results, latestEvent } = action.payload.data.users

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          data: results,
          latestEvent,
        })
      })

    case FETCH_USERS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: [],
        }),
      )

    case FETCH_USERS.CLEANUP:
      return { ...USERS_INITIAL_STATE }

    case DELETE_USER.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: nextState.data,
          idToDelete: action.payload.id,
          latestEvent: undefined,
        }),
      )

    case DELETE_USER.COMPLETE:
      return produce(state, nextState => {
        const { id: deletedId, latestEvent } = action.payload.data.deleteUser

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          data: filter(nextState.data, ({ id }) => id !== deletedId),
          idToDelete: undefined,
          latestEvent,
        })
      })

    case DELETE_USER.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: nextState.data,
          idToDelete: nextState.idToDelete,
        }),
      )

    default:
      return state
  }
}

export default usersReducer
